import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
    usuariosDisponiveis: [],
    clientesDisponiveis: [],
    imoveisDisponiveis: [],
    proprietariosDisponiveis: [],
}

const mutations = {
  atualizarUsuariosDisponiveis(state, payload) {
    state.usuariosDisponiveis = payload
  },
  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload
  },
  atualizarImoveisDisponiveis(state, payload) {
    state.imoveisDisponiveis = payload
  },
  atualizarProprietariosDisponiveis(state, payload) {
    state.proprietariosDisponiveis = payload;
  }
}

const actions = {
  listarUsuarios(context, payload) {
    return axios.post(URLS.USUARIOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuariosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarUsuarios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarUsuariosDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarClientesDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarImoveisDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarProprietarios(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarProprietariosDisponiveis', response.data.lista)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarProprietarios', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },
  listarAlugueis(context, payload) {
    return axios.post(URLS.ALUGUEIS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarAlugueis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarRelatorio(context, payload) {
    let ENDPOINT;

    switch (payload.nome) {
      case 'CLIENTES_POR_CORRETOR':
      case 'CONTATOS_REALIZADOS':
          ENDPOINT = URLS.RELATORIOS_GERAR_RELATORIO_CLIENTES_VENDA;  
          break;
      case 'CLIENTES_ALUGUEL':
          ENDPOINT = URLS.RELATORIOS_GERAR_RELATORIO_CLIENTES_ALUGUEL
        break;
      case 'CONTRATO_ALUGUEL':
          ENDPOINT = URLS.RELATORIOS_GERAR_RELATORIO_CONTRATOS_ALUGUEL
        break;
      case 'IMOVEIS_ALUGUEL':
          ENDPOINT = URLS.RELATORIOS_GERAR_RELATORIO_IMOVEIS_ALUGUEL
        break;
        case 'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL':
          ENDPOINT = URLS.RELATORIOS_GERAR_RELATORIO_IMOVEIS_ALUGUEL
        break;  
      default:
          ENDPOINT = URLS.RELATORIOS_GERAR;
        break;
    }

    return axios.post(ENDPOINT, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarRelatorio', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
}

export default {
  state,
  mutations,
  actions
}